
import Button from '../components/base/Button';

export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-sky-50 to-emerald-50 pt-16">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-10"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20minimalist%20clean%20home%20interior%20with%20natural%20light%20streaming%20through%20large%20windows%2C%20spotless%20white%20surfaces%2C%20fresh%20plants%2C%20and%20a%20serene%20atmosphere%20that%20conveys%20cleanliness%20and%20tranquility%2C%20professional%20cleaning%20service%20aesthetic%2C%20bright%20and%20airy%20space%20with%20contemporary%20design%20elements&width=1920&height=1080&seq=hero-bg&orientation=landscape')`
        }}
      ></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold text-slate-900 mb-6 font-outfit leading-tight">
            Espacios impecables,{' '}
            <span className="text-sky-500">mente despejada</span>
          </h2>
          
          <p className="text-xl md:text-2xl text-slate-600 mb-8 max-w-3xl mx-auto leading-relaxed font-inter">
            Limpieza profesional con productos eco-friendly y satisfacción garantizada. 
            Transformamos tu espacio para que puedas enfocarte en lo que realmente importa.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Button 
              onClick={scrollToContact}
              size="lg"
              className="text-lg px-10 py-4"
            >
              Cotiza hoy
            </Button>
            <div className="flex items-center gap-6 text-slate-600">
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-line text-emerald-500 text-xl"></i>
                <span className="font-medium">100% Garantizado</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-leaf-line text-emerald-500 text-xl"></i>
                <span className="font-medium">Eco-friendly</span>
              </div>
            </div>
          </div>
          
          {/* Trust Indicators */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-2xl mx-auto">
            <div className="flex items-center justify-center gap-3 text-slate-600">
              <i className="ri-award-line text-sky-500 text-2xl"></i>
              <span className="font-medium">Insured & Bonded</span>
            </div>
            <div className="flex items-center justify-center gap-3 text-slate-600">
              <i className="ri-user-heart-line text-sky-500 text-2xl"></i>
              <span className="font-medium">Equipos Verificados</span>
            </div>
            <div className="flex items-center justify-center gap-3 text-slate-600">
              <i className="ri-time-line text-sky-500 text-2xl"></i>
              <span className="font-medium">Servicio Puntual</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
